// import { BsYoutube } from 'react-icons/bs';
import { FaFacebookF,FaInstagram } from "react-icons/fa6";
import { FaYoutube } from "react-icons/fa";
import {AiOutlineWhatsApp} from 'react-icons/ai';
export const iconList = {
    FaFacebookF,
    FaInstagram ,
    FaYoutube ,
    AiOutlineWhatsApp
};